'use client';

import fork from '@haaretz/l-fork.macro';
import TextField from '@haaretz/s-text-field';
import React from 'react';
import s9 from 'style9';

import type { TextFieldProps } from '@haaretz/s-text-field';

const c = s9.create({
  rtl: {
    direction: 'rtl',
  },
});

const defaultPhoneText = fork({
  default: 'אנא הזינו מספר טלפון',
  hdc: 'Please enter a valid phone number',
});

export default function PhoneField(props: TextFieldProps) {
  const [errorPhone, setErrorPhone] = React.useState(defaultPhoneText);

  return (
    <TextField
      type="tel"
      label={fork({ default: 'טלפון', hdc: 'Phone' })}
      required
      name={props.name || 'phone'}
      pattern={fork({
        default: '^0(?:[23489]|5\\d|7[2-9])\\d{7}$',
        hdc: '^(0\\d{1,2}-)?\\d{6,12}$',
      })}
      maxLength={fork({ default: 10, hdc: 12 })}
      onInput={() => setErrorPhone(defaultPhoneText)}
      styleExtend={props.styleExtend}
      inputStyleExtend={[fork({ default: c.rtl, hdc: null })]}
      onInvalid={e => {
        e.preventDefault();
        setErrorPhone(
          fork({
            default: 'מספר הטלפון שהוזן אינו תקין',
            hdc: 'Invalid phone number',
          })
        );
      }}
      isInvalid={errorPhone !== defaultPhoneText}
      description={errorPhone}
    />
  );
}
